import { flatten, omit } from 'lodash';
/** Flattens a hierarchy of routes into an array */
export function flattenRoutes(routes, maxDepth) {
    const nextDepth = maxDepth && maxDepth - 1;
    return flatten(routes.map((route) => {
        const subRoutes = nextDepth === undefined || nextDepth > 1
            ? flattenRoutes(route.routes ?? [], nextDepth)
            : [];
        return [omit(route, 'routes'), ...subRoutes];
    }));
}
